import { supabase } from '@/integrations/supabase/client';

/**
 * Repair embeddings for the current logged-in user
 * This uses JWT authentication to ensure only the user can repair their own embeddings
 */
export const repairMyEmbeddings = async () => {
  console.log('🔧 Starting embedding repair for current user...');
  
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      console.error('❌ No user logged in');
      return { success: false, error: 'No user logged in' };
    }

    console.log(`🔧 Repairing embeddings for user: ${user.id.slice(0, 8)}...`);

    const { data, error } = await supabase.functions.invoke('repair-entry-embeddings', {
      body: {} // No userId needed - authenticated via JWT
    });
    
    if (error) {
      console.error('❌ Error repairing embeddings:', error);
      return { success: false, error };
    }
    
    console.log('✅ Repair complete:', data);
    return { success: true, data };
  } catch (err) {
    console.error('❌ Exception during repair:', err);
    return { success: false, error: err };
  }
};

// Make it available globally in dev mode for easy console access
if (typeof window !== 'undefined') {
  (window as any).repairEmbeddings = repairMyEmbeddings;
}
